import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type { ExtractionReviewViewMode } from 'src/types/fieldExtraction';

export interface SetUserPreferencesParams {
  stackSearchFilterId?: string;
  fieldStackFilterId?: string;
  documentStackFilterId?: string;
  extractionReviewViewMode?: ExtractionReviewViewMode;
  guidelineBuddyVerificationToken?: string | null;
}

export interface SetUserPreferencesResponse {
  data: {
    stackSearchFilterId?: string;
    fieldStackFilterId?: string;
    documentStackFilterId?: string;
    extractionReviewViewMode?: ExtractionReviewViewMode | null;
    guidelineBuddyVerificationToken?: string | null;
  };
}

const setUserPreferences: MutationFunction<
  SetUserPreferencesResponse,
  SetUserPreferencesParams
> = async (args) => {
  if (isMockServices())
    return await mock({ data: args }, { delay: 1000, failureRate: 0 });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetUserPreferencesResponse>(
    '/shared/user/preferences',
    {
      method: 'POST',
      body: {
        stackSearchFilterId: args.stackSearchFilterId,
        fieldStackFilterId: args.fieldStackFilterId,
        documentStackFilterId: args.documentStackFilterId,
        extractionReviewViewMode: args.extractionReviewViewMode,
        guidelineBuddyVerificationToken: args.guidelineBuddyVerificationToken,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set user preferences');
};

const _mockUserPreferences = (args: SetUserPreferencesParams) => ({
  data: {
    ...args,
  },
  success: true,
});

export { _mockUserPreferences };
export default setUserPreferences;
